export enum Product {
  STANDARD_BANK = 'bank',
  DEPOSIT_ACCOUNT = 'depositumskonto',
  SMART_PENSION = 'smartpensjon',
  CONSUMER_LOAN = 'forbrukslan',
  FIXED_DEPOSIT_3_MONTHS = 'fastrenteinnskudd-3',
  FIXED_DEPOSIT_6_MONTHS = 'fastrenteinnskudd-6',
  HIGH_INTEREST_ACCOUNT_HUSEIERNE = 'hoyrentekonto-huseierne',
  HIGH_INTEREST_ACCOUNT = 'hoyrentekonto',
  PLACEMENT_ACCOUNT_ORDINARY = 'plasseringskonto',
  EMERGENCY_FUNDS_ORDINARY = 'bufferkonto',
  HIGH_INTEREST_ACCOUNT_WEALTH = 'formue',
  FRAM = 'fram',
  SAVINGS_ACCOUNT = 'sparekonto',
  PRIVATE_BANKING = 'private-banking',
}

export enum ExternalProductSearchParams {
  originReference = 'originReference',
  coreApplicationId = 'coreApplicationId',
}

export enum FeatureFlags {
  UNDER_MAINTENANCE = 'bank-onboarding-web-under-maintenance',
}
